document.addEventListener("DOMContentLoaded", () => {
  const initializeSizeGuides = () => {

    document.querySelectorAll(".size-guide").forEach((guide) => {

      if (guide.dataset.initialized === "true") return;

      guide.dataset.initialized = "true";

      const trigger =
        guide.querySelector(".size-guide__trigger");

      const overlay =
        guide.querySelector(".size-guide__overlay");

      const closeButton =
        guide.querySelector(".size-guide__close");

      if (!trigger || !overlay || !closeButton) return;


      const openGuide = () => {

        overlay.classList.add("is-open");

        overlay.setAttribute(
          "aria-hidden",
          "false"
        );

        document.body.style.overflow = "hidden";
      };


      const closeGuide = () => {

        overlay.classList.remove("is-open");

        overlay.setAttribute(
          "aria-hidden",
          "true"
        );

        document.body.style.overflow = "";
      };


      trigger.addEventListener(
        "click",
        openGuide
      );


      closeButton.addEventListener(
        "click",
        closeGuide
      );


      overlay.addEventListener(
        "click",
        (event) => {

          if (event.target === overlay) {
            closeGuide();
          }

        }
      );


      document.addEventListener(
        "keydown",
        (event) => {

          if (
            event.key === "Escape" &&
            overlay.classList.contains("is-open")
          ) {

            closeGuide();

          }

        }
      );

    });

  };


  initializeSizeGuides();


  document.addEventListener(
    "shopify:section:load",
    initializeSizeGuides
  );

});